// src/utils/authProviders.js

export const normalizeEmail = (email) => (email || '').trim().toLowerCase();

export const analyzeMethods = (methods = []) => {
  const hasPassword = methods.includes('password');
  const hasGoogle = methods.includes('google.com');
  const isEmpty = methods.length === 0;
  return { hasPassword, hasGoogle, isEmpty };
};

export const buildProviderAdvice = ({ hasPassword, hasGoogle, isEmpty }) => {
  if (isEmpty) {
    return {
      type: 'error',
      message: "Aucun compte n'est associé à cet email. Vous pouvez vous inscrire.",
    };
  }
  if (hasGoogle && !hasPassword) {
    return {
      type: 'error',
      message: "Le compte lié à cette adresse utilise l'authentification Google. Utilisez le bouton 'Se connecter avec Google'.",
    };
  }
  return null;
};

export const buildResetAdvice = ({ hasPassword, hasGoogle, isEmpty }) => {
  if (isEmpty) {
    return {
      type: 'error',
      message: "Aucun compte trouvé pour cet email.",
    };
  }
  if (!hasPassword && hasGoogle) {
    return {
      type: 'error',
      message: "Ce compte utilise Google. La réinitialisation du mot de passe n'est pas applicable.",
    };
  }
  if (hasPassword) {
    return {
      type: 'info',
      message: 'Email de réinitialisation envoyé. Vérifiez votre boîte de réception.',
    };
  }
  return null;
};
